import img2048 from "../img/2048.png";
import imgJetson from "../img/archOnCrash.png";
import imgOnlineDic from "../img/onlineDictionary.png";
import imgHelm from "../img/helm.png";

export let projects = {
  1: {
    name: " Jetson Notification Service ",
    description: [
      "With the publicly available Telegram bot @road_guards_bot that I created, users can subscribe to it to receive alerts related to a specific vehicle.",
      "The jetson module inside the car will make a call to our API in case of a crash, resulting in a message from the bot (containing the location of the accident as a Google Maps URL) being sent to all the subscribers.",
    ],
    img: imgJetson,
    github:
      "https://github.com/AbdelrahmanDeghedy/Jetson-Notification/tree/main",
    technologies: ["Node.js", "MongoDB", "APIs"],
  },
  2: {
    name: "Online Dictionary Learning for Sparse Coding",
    description: [
      "This repository contains the implementation of the online learning algorithms for sparse coding proposed by Julien Mairal in his paper titled 'Online Learning for Matrix Factorization and Sparse Coding'",
      "Sparse coding is a fundamental technique in machine learning and signal processing, with numerous applications in recommendation systems, image processing, and data analysis. While traditional approaches often rely on batch learning algorithms, online learning methods provide a more efficient and scalable solution, enabling real-time updates and adaptivity to changing data streams.",
    ],
    img: imgOnlineDic,
    github:
      "https://github.com/AbdelrahmanDeghedy/Online-Dictionary-Learning-for-Sparse-Coding",
    technologies: ["Python", "CVX", "Optimization"],
  },
  3: {
    name: "Helm Visualization Tool",
    description: [
      "It's a visual web wpp, and a wesktop app that manages your helm charts' releases, compare their revisions (by viewing the difference between different YAML files), and get summary of their components (pods/deployments/services) status.",
    ],
    img: imgHelm,
    github: "https://github.com/tactful-ai/helm-dashboard",
    technologies: ["Docker", "Kubernetes", "Electron", "VueJs", "Typescript"],
  },
  4: {
    name: "2048 Game",
    description: [
      "It's a game in which, we combine numbered tiles in order to gain a higher numbered tile.",
      "In this game you start with two tiles, the lowest possible number available is two. Then you will play by combining the tiles with the same number to have a tile with the sum of the number on the two tiles.",
      "I created it using HTML, SASS, vanilla Javascript.",
    ],
    img: img2048,
    github: "https://github.com/AbdelrahmanDeghedy/2048-Game",
    technologies: ["HTML", "SASS", "Javascript"],
  },
  // 5: {
  //   name: "Evaluate News Articles",
  //   description: [
  //     "This project aims to build a web tool that allows users to run Natural Language Processing (NLP) on articles or blogs found on other websites.",
  //     "When a user submits a URL of an article, the web page then dispalys sentiment analysis returned from meaningcloud API, based on the contents of the article.",
  //   ],
  //   img: imgEvaluateNewsNlp,
  //   github: "https://github.com/AbdelrahmanDeghedy/Evaluate-News-Articles-NLP",
  //   technologies: ["HTML", "CSS", "Javascript", "node", "express", "webpack"],
  // },
};

export let quotes = {
  1: {
    content: "This journey 1% finished.",
    author: "Was a common saying inside Meta",
  },
  2: {
    content: "Quality of questions determines the quality of answers.",
    author: "Me",
  },
  3: {
    content:
      "Plans are fragile, short-lived, and imperfect, but without them, life became a complete mess.",
    author: "Me",
  },
  4: {
    content:
      "Resentment is like drinking poison and then hoping it will kill your enemies.",
    author: "Mandela",
  },
  5: {
    content:
      "Compare Yourself to Who You Were Yesterday, Not to Who Someone Else is Today.",
    author: "Jordan Peterson",
  },
  6: {
    content:
      "If you realize how powerful your thoughts are, you will never think a negative thought.",
    author: "Peace Pilgrim",
  },
  7: {
    content:
      "People fall so in love with their pain, they can’t leave it behind. The same as the stories they tell. We trap ourselves.",
    author: " Chuck Palahniuk, Haunted",
  },
  8: {
    content: "Not everything worth doing is worth doing well.",
    author: "Tom West",
  },
  9: {
    content: "It's all just us, in here together. We're all we've got. ",
    author: "Lex Luthor",
  },
  10: {
    content: "Familiarity breeds contempt.",
    author: "Old proverb",
  },
  11: {
    content:
      "Holding on to anger is like grasping a hot coal with the intent of throwing it at someone else; you are the one who gets burned.",
    author: "Buddha",
  },
};
